/** @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import { displayPercent } from 'common/components/Number';
import { TooltipWrapper, TooltipTitle, TooltipItemList, TooltipItem } from '../../../components/charts/tooltip/RechartsToolTipStyles';

const Wrapper = styled(TooltipWrapper)`
  white-space: normal;
`;

type TooltipProps = {
  active?: boolean;
  label?: string;
  payload?: Array<Object>;
  theme: Object;
  t: any;
}

function AgeRangeGraphTooltip({ active, payload, label, theme, t }: TooltipProps) {
  if (!active || !payload) {
    return null;
  }

  const p = payload[0];
  const { color, value } = p;
  const isInterpolated = p.payload.interpolated;

  return (
    <Wrapper>
      <TooltipTitle>{label}</TooltipTitle>
      <TooltipItemList>
        { value !== 0 &&
          <TooltipItem color={color}>
            { t('percentage') } : { displayPercent(value / 100) }
          </TooltipItem>
        }
        { value === 0 &&
          <TooltipItem color={theme.colors.warning}>
            { t('insufficientData') }
          </TooltipItem>
        }
        { isInterpolated &&
          <TooltipItem color={theme.colors.warning}>
            { t('lackOfSampling') }
          </TooltipItem>
        }
      </TooltipItemList>
    </Wrapper>
  );
}

export default withTheme(translate()(AgeRangeGraphTooltip));



// WEBPACK FOOTER //
// ./src/common/components/charts/tooltip/AgeRangeGraphTooltip.js